import { Result, Button } from 'antd';

export function Error500(){
  return(
<Result
    status="500"
    title="500"
    subTitle="Sorry, the page you visited does not exist."
    extra={<Button type="primary">Back Home</Button>}
  />
  )
}